import React from 'react'
import { WebsiteTypographyGroup } from 'src/editor/shared/settings/wrappers/entity-and-website-typography-group/website-typography-group'
import {
  getWebsiteStylesTypographyHeading,
  getWebsiteStylesTypographyParagraph,
} from 'src/editor/store/website-settings/website-settings-selector'
import {
  updateWebsiteStylesHeadingTypography,
  updateWebsiteStylesParagraphTypography,
} from 'src/editor/store/website-settings/website-settings-actions'
import { WebsiteTypographySettingsStylesInterface } from 'src/editor/store/website-settings/website-settings-types'
import { useWebsiteSettings } from 'client/store'
import { useHeadingTypography } from 'src/editor/shared/hooks/use-heading-typography'

export const WebsiteStylesSettingsTypography = () => {
  const paragraphTypography = useWebsiteSettings(
    getWebsiteStylesTypographyParagraph,
  ) as WebsiteTypographySettingsStylesInterface
  const headingTypography = useWebsiteSettings(
    getWebsiteStylesTypographyHeading,
  ) as WebsiteTypographySettingsStylesInterface

  return (
    <>
      <WebsiteTypographyGroup
        typographyObject={paragraphTypography}
        updateTypographyAction={updateWebsiteStylesParagraphTypography}
        title="Heading"
        isFirst
        isRootSetting
      />
      <WebsiteTypographyGroup
        typographyObject={headingTypography}
        updateTypographyAction={updateWebsiteStylesHeadingTypography}
        typographyHook={useHeadingTypography}
        title="Paragraph"
        isRootSetting
      />
    </>
  )
}
